import { Component } from '@angular/core';

@Component({
  selector: 'hadsup-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
  standalone: false,
})
export class TermsAndConditionsComponent {

}
